import { forwardRef, useState } from 'react';
import {
    ThemeImageProps,
    TLazyImageStatus,
} from './interface';
import { ImageContainer } from '@base/lib/ThemeImage/ImageContainer';
import { LazyImage } from '@base/lib/ThemeImage/LazyImage';
import { getProps } from '@base/lib/ThemeImage/utils';
export type { ThemeImageProps } from './interface';

export const Image = forwardRef<HTMLElement, ThemeImageProps>((props, ref) => {
    const [status, setStatus] = useState<TLazyImageStatus>('loading');

    const { containerProps, imageProps } = getProps(props, status);

    return (
        <ImageContainer ref={ref} {...containerProps}>
            <LazyImage
                {...imageProps}
                onChangeStatus={setStatus}
            />
        </ImageContainer>
    )
});

export default Image;